import { Component, onMount, onCleanup } from "solid-js";
import { useItemOrderContext } from "~/utils/contexts";
import { Icon } from "solid-heroicons";
import { check } from "solid-heroicons/outline";
import { PT } from "~/utils/products";

export const FreightChargeAcknowledge: Component = () => {
  const { orderData, setOrderData } = useItemOrderContext();
  onMount(() => {
    setOrderData("selected", "freightChargeConsent", undefined);
  });
  onCleanup(() => {
    setOrderData("selected", "freightChargeConsent", undefined);
  });
  return (
    <div class="border bg-faint-blue p-3 flex items-center text-sm text-roma-dark-grey">
      <button
        aria-label={
          !orderData.selected.freightChargeConsent
            ? "Check freight charge consent box"
            : "Uncheck freight charge consent box"
        }
        class="ml-2 w-5 aspect-square shrink-0 flex justify-center items-center self-center"
        classList={{
          "bg-white border": !orderData.selected.freightChargeConsent,
          "bg-roma-blue": !!orderData.selected.freightChargeConsent,
        }}
        onClick={() => {
          setOrderData(
            "selected",
            "freightChargeConsent",
            !orderData.selected.freightChargeConsent
          );
        }}
      >
        <Icon path={check} class="text-white w-4" stroke-width={3} />
      </button>
      <p class="ml-4">
        As a result of your selection, you agree to the additional LTL freight
        charges that{" "}
        {orderData.selected.productType === PT.LENGTH &&
        orderData.defaultShipsFrom === orderData.selected.shipsFrom &&
        orderData.selected.cuttingInstr == "full"
          ? "may"
          : "will"}{" "}
        be incurred.
      </p>
    </div>
  );
};
